module.exports = __webpack_public_path__ + "img/cloud-upload-alt.758fa0fc.svg";